// extracted by mini-css-extract-plugin
export var arrow = "_c8-1";
export var content = "_c8-0";
export var highlighted = "_c8-2";